// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"8e5632ca","281":"78654dcf","357":"73249178","453":"06ac5b0d","504":"0e5f52cb","985":"e5312c30"}[chunkId] + ".chunk.js";
};